import {
  MotifButton,
  MotifCard,
  MotifCardBody,
  MotifCardHeader,
  MotifIcon,
  MotifProgressLoader
} from '@ey-xd/motif-react';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PrivilegesListTable from '../molecules/PrivilegesListTable';
import AdminPageHeader from '../molecules/AdminPageHeader';

const Privileges = () => {
  const [search, setSearch] = React.useState('');

  const navigate = useNavigate();
  const { privileges } = useSelector((state: any) => state.admin);
  const { access } = useSelector((state: any) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    const {read} = access;
    if(read) {
      dispatch(
        {
          type: 'GET_PRIVILEGES'
        },
        {}
      );
    }
  }, [access]);
  
  const triggerSearch = () => {
    
  };
  useEffect(() => {
    triggerSearch();
  }, [search]);

  const filteredData = privileges?.filter(item =>
    (item.Privilege_name ?? "").toLowerCase().includes(search.toLowerCase()) ||
    (item.Privilege_status ?? "").toLowerCase().includes(search.toLowerCase()) ||
    (item.Privilege_Description ?? "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="flex flex-col min-h-full m-3">
      <MotifCard className="min-h-[50vh] !bg-[transparent]">
        <MotifCardHeader className="!py-0" style={{ borderBottom: '1px solid #ffffff26' }}>
          <div className="flex gap-10 items-center !justify-between !w-full">
            <h4 className='!py-3 !font-bold'>Privileges</h4>
            <div>
              <MotifButton
                disabled={access.write === false}
                title={access.write === false ? "Write access denied" : ""}
                onClick={() => {
                  navigate('/privileges/add');
                }}
                size="small"
                className="!rounded-none !h-[30px] inline"
              >
                + Add new privilege
              </MotifButton>
            </div>
          </div>
        </MotifCardHeader>
        <MotifCardBody className="!min-h-80">
          <AdminPageHeader
            search={search}
            setSearch={setSearch}
            title={"Below listed are the privileges"}
          />
          {access.read === false && (
            <p className="text-center font-bold">Read access denied</p>
          )}
          {filteredData && (
          <PrivilegesListTable tableData={filteredData} />
          )}
        </MotifCardBody>
      </MotifCard>
    </div>
  );
};

export default Privileges;